
<template>
  <div class="pagebox">
    <div class="page_head">
      <el-select class="langSel" v-model="thisLang" :placeholder="$t('m.select')" size="small">
        <el-option v-for="item in langArrs" :key="item.key" :label="item.name" :value="item.key">
        </el-option>
      </el-select>
    </div>
    <div class="maincon">
      <div class="maincon_bg">
        <img src="../assets/img/login_bg.png" alt="">
      </div>
      <!--登录界面-->
      <div class="login_box">
        <img class="loginTypeArrow ar_img" v-if="scanLogin==2" src="../assets/img/computer.png" @click="scanLogin=1;hideXieyi=false">
        <img class="loginTypeArrow ar_img" v-if="scanLogin==1" src="../assets/img/scanlog.png" @click="scanLogin=2;hideXieyi=false">

        <div class="login_form">
          <!--扫码登录-->
          <scan-login v-if="scanLogin==2" :agreeXieyi="checked" ref="codeView"></scan-login>
          <change-phone v-else-if="loginType==2" @changephone="changephone" :agreeXieyi="checked"></change-phone>

          <!--短信验证码登录-->
<!--          <sms-login v-else-if="loginType==1" @changephone="changephone" :agreeXieyi="checked"></sms-login>-->

          <!--手机号、密码登录-->
          <login-register-tab v-else-if="loginType==1" @hide="hide" :agreeXieyi="checked"/>
        </div>
        <div class="xieyibox" :class="{'sm':loginType==2}" v-if="!hideXieyi">
          <input class="checkbox" type="checkbox" id="xieyi" v-model="checked">
          <label class="checkboxlabel fc-pointer" for="xieyi"></label>
          <span class="fc-mar-lr-min" for="xieyi" v-html="$t('m.log_reg_agree',{'msg_ss':'<a class=\'fc-color-main\' href=\''+getH5Url()+'/article/guildAgree/index.html?lang='+$store.state.localeLang+'\' target=\'_blank\'>《'+$t('m.community_convention')+'》</a>'})"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import smsLogin from "@/components/login/sms";
import changephone from "@/components/login/changephone";
import scanLogin from "@/components/login/scanLogin";
import loginRegisterTab from "@/components/login/loginRegisterTab";
import {userLangArr} from "../utils/common";
  export default {
    components: {
      "sms-login": smsLogin,
      "change-phone": changephone,
      "scan-login": scanLogin,
      loginRegisterTab
    },
    data() {
      return {
        thisLang:this.$store.state.localeLang,
        langArrs: userLangArr,
        scanLogin:1,//1手机号登录 2扫码登录
        loginType:1,//登录方式 手机号，2更换手机号
        checked:false,
        hideXieyi: false
      }
    },
    watch:{
      thisLang(val){
        this.$store.commit("setLanguage",val);
        if(this.scanLogin === 2) {
          this.$refs.codeView.updateCode()
        }
      }
    },
    mounted(){
      // console.log(this.$store.state.localeLang)
    },
    methods:{
      /**
       * 获取h5地址，菲律宾的返回https://static.buzzcast.buzz
       * @returns {string|*|string}
       */
      getH5Url() {
        let host = window.location.host
        if(host === 'guild.buzzcast.buzz') {
            return process.env.PH_H5URL
        }
        return process.env.H5URL
      },
      hide(val) {
        console.log("hide:"+val)
        this.hideXieyi = val
      },
      changephone(e){
        this.loginType=e;
      }
    },
  };
</script>

<style lang="less">
@media only screen and (max-width: 767px){
  .langSel{
    .el-input__inner{
      background-color: transparent;
      color: #fff;
    }
    .el-select__caret{
      color: #fff !important;
    }
  }
}

</style>
<style scoped lang="less">

  img{
    vertical-align: middle;
  }
  .pagebox{
    width: 100%;
    min-height: 100vh;
    position: relative;
  }
  .page_head{
    display: flex;
    justify-content: flex-end;
    padding: 30px;
  }
  .langSel{
    width: 150px;
    z-index: 99;
  }
  .maincon{
    width: 98%;
    max-width: 1200px;
    height: 59vw;
    max-height: 720px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    margin: auto;
    //background-color: #fff;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    box-shadow: 0px .05rem .16rem 0 #766E84;
  }
  .maincon_bg{
    width: 50%;
    height: 100%;
  }
  .maincon_bg img{
    width: 100%;
    height: 100%;
  }
  .login_box{
    width: 50%;
    height: 100%;
    position: relative;
    border-radius: .32rem;
    background-color: rgba(255, 255, 255, .9);
    .loginTypeArrow{
      width: 1.04rem;
      height: 1.04rem;
      position: absolute;
      top: 0;
      right: 0;
    }
  }
  .login_form{
    width: 100%;
    box-sizing: border-box;
  }
.checkboxlabel{
    width: 20px;
    height: 20px;
    flex: 0 0 20px;
    padding: 0;
    background-image: url('../assets/img/radio.png');
    background-size: 100% 100%;
    display: inline-block;
}
.checkbox{
    //opacity: .1;
    visibility: hidden;
}
.checkbox[type=checkbox]:checked + .checkboxlabel {
	background-image: url('../assets/img/radio_sel.png');
}
.xieyibox{
  width: 100%;
  display: flex;
  align-items: center;
  color: #999;
  justify-content: center;
  font-size: .14rem;
  margin-left: -14px;
  // padding-bottom: .3rem;
  position: absolute;
  bottom: .3rem;
  right: 12px;
  // &.sm{
  //   padding: .2rem 0;
  // }
}
@media only screen and (max-width: 767px){

  .pagebox{
    background-image: url('../assets/img/login_bg_2.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    font-size: 13px;
  }
  .maincon{
    width: 80%;
    height: auto;
    box-shadow: none;
    top:45%
  }
  .maincon_bg{
    //width: 100%;
    display: none;
  }
  .login_box{
    width: 100%;
    overflow: hidden;
  }
  .login_form{
    padding-bottom: .9rem;
  }
  .xieyibox{
    font-size: .2rem;
  }
}

.ar{
  .loginTypeArrow{
    left: 0;
    right: initial;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/login.vue